import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, colors, shadows }) => ({
  overlay: {
    ...StyleSheet.absoluteFill,
    alignItems: "flex-end",
    justifyContent: "flex-start",
    paddingTop: spacing(12),
  },
  toast: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(3),
    paddingVertical: spacing(5),
    paddingHorizontal: spacing(8),
    backgroundColor: colors.backgroundInverted,
    shadowColor: shadows.modal,
    shadowOffset: { width: 0, height: spacing(1) },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 6,
  },
  icon: {
    width: spacing(6),
    height: spacing(6),
    color: colors.foregroundOnInverted,
  },
  label: {
    color: colors.foregroundOnInverted,
  },
}));

export default stylesheet;
